export const layoutTypes = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
}
